module.exports = __webpack_public_path__ + "img/interface OneB Mapper_6 prew.daf17470.jpg";